var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6083 0H4.39167L0 4.39167V10.6083L4.39167 15H10.6083L15 10.6083V4.39167L10.6083 0ZM13.3333 9.91667L9.91667 13.3333H5.08333L1.66667 9.91667V5.08333L5.08333 1.66667H9.91667L13.3333 5.08333V9.91667ZM9.85833 3.96667L7.5 6.325L5.14167 3.96667L3.96667 5.14167L6.325 7.5L3.96667 9.85833L5.14167 11.0333L7.5 8.675L9.85833 11.0333L11.0333 9.85833L8.675 7.5L11.0333 5.14167L9.85833 3.96667Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCross);
export default __webpack_public_path__ + "static/media/deleteCross.159a5daa6f4699af1ac01ef75e784e15.svg";
export { ForwardRef as ReactComponent };